import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import './antd-custom.css';
import 'react-image-lightbox/style.css'
import 'react-html5-camera-photo/build/css/index.css';
import App from './App';
import { BrowserRouter, Route } from 'react-router-dom';
import { ConfigProvider } from 'antd';

   function getCspNonce(): string {
       const meta = document.querySelector<HTMLMetaElement>('meta[property="csp-nonce"]');
       return meta ? meta.content : '';
   }
   const currentNonce = getCspNonce();
    
    
ReactDOM.render(
    <ConfigProvider csp={{ nonce: currentNonce }}>
      <BrowserRouter>
        <Route path="/:region/:path" component={App} />
      </BrowserRouter>
    </ConfigProvider>,
  document.getElementById('root')
);

